

































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { fetchAdd } from '../../fetchAdd';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';

@Component({ components: {} })
export default class TabReservationsEdit extends Vue {
  @Prop({ required: true, default: {} }) data!: any;
  showEdit: boolean = false;
  readonly loadingService = new LoadingService();
  readonly modulo_id: Funcionalidades = Funcionalidades.ModalNDVReservas;
  $snotify: any;
  CRM_serie_old = this.data['CRM Serie'];
  series: any = [];
  selectedSerie: any = '';
  selectedSerie_old: any = '';
  constructor() {
    super();
    this.getSeries();
  }
  handleCancel() {
    this.$emit('cerrar');
  }

  async edit(): Promise<void> {
    this.loadingService.showLoading();
    const userId = this.getUserId();
    const id_cliente = this.getClientId();
    const user = localStorage.getItem('user');
    const rut = JSON.parse(user.replace(/'/g, '"')).rutClienteDefecto;
    const self = this;
    this.data['CRM Serie'] = this.selectedSerie.text;
    this.selectedSerie_old = this.selectedSerie;
    return await fetchAdd({
      endpoint: 'edit',
      body: {
        userId,
        rut,
        id_cliente,
        modulo_id: this.modulo_id,
        CRM_serie_old: this.CRM_serie_old,
        ...this.data,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          this.selectedSerie = this.selectedSerie_old;
          return self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        self.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
        return this.$emit('cerrar');
      })
      .catch((error: Error) => {
        console.error(error.message);
        this.selectedSerie = this.selectedSerie_old;
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => self.loadingService.hideLoading());
  }
  beforeDestroy() {
    this.$emit('cerrar');
  }
  async getSeries() {
    await fetchAdd({
      serviceClient: 'ltConectaNDV',
      endpoint: 'get_series',
      body: {},
    })
      .then(response => {
        this.loadingService.showLoading();
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          return this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        // this.series = response.data['LISTA'];
        this.series = response.data['LISTA'].map(
          (item: { key: any; value: any }) => ({
            text: item.key,
            value: item.value,
          })
        );
        const newSerie = this.createSerieObject();
        this.series.unshift(newSerie);
        this.selectedSerie = newSerie;
        return response.data;
      })
      .catch((error: Error) => {
        //console.error(error.message);
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => this.loadingService.hideLoading());
  }
  getUserId = (): number => {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  };
  getClientId = (): number => {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).clienteDefecto;
    return parseInt(id);
  };
  createSerieObject() {
    return {
      text: this.data['CRM Serie'],
      value: this.data['CRM Serie'] + ' - SERIE ACTUAL',
    };
  }
}
